import { useEffect, useMemo, useState } from 'react'

export const useSelectItems = <TValue>(newItems: TValue[], showAlwaysItemsCount: number | undefined) => {
  const allItems = useMemo<TValue[]>(() => newItems, [newItems])
  const [renderedItems, setRenderedItems] = useState<TValue[]>(allItems)
  useEffect(() => {
    setRenderedItems(allItems)
  }, [allItems])

  return {
    allItems,
    renderedItems: showAlwaysItemsCount ? renderedItems.slice(0, showAlwaysItemsCount) : renderedItems,
    setRenderedItems
  }
}
